import { PREFERENCE_TYPES } from '../../constants/preference-types';
import { translate } from '@td/shared_utils';

const locales = {
  notifyBoxTitle:          translate(null, 'notification_preferences.checkboxes', 'notify_box_title'),
  browserNotificationName: translate(null, 'notification_preferences.checkboxes', 'browser_notification'),
  emalNotificationName:    translate(null, 'notification_preferences.checkboxes', 'email_notification'),
  additionalBoxTitle:      translate(null, 'notification_preferences.checkboxes', 'additional_box_title'),
  emergencyName:           translate(null, 'notification_preferences.checkboxes', 'emergency'),
  threeWayCallName:        translate(null, 'notification_preferences.checkboxes', 'three_way_call'),
  liveAgentName:           translate(null, 'notification_preferences.checkboxes', 'live_agent'),
  emotionalDistress:       translate(null, 'notification_preferences.checkboxes', 'emotional_distress'),
};

const { notifyBoxTitle, browserNotificationName, emalNotificationName, additionalBoxTitle, emergencyName, threeWayCallName, liveAgentName, emotionalDistress } = locales;

export const DATA = {
  notifyBox: {
    title:      notifyBoxTitle,
    properties: [
      {
        name:       browserNotificationName,
        value:      'browser',
        disabled:   true,
        checked:    true,
        hasTooltip: true
      },
      {
        name:       emalNotificationName,
        value:      'email',
        disabled:   true,
        checked:    false,
        hasTooltip: false
      }
    ]
  },
  additionalBox: {
    title:      additionalBoxTitle,
    properties: [
      {
        name:       emergencyName,
        value:      PREFERENCE_TYPES.emergency,
        disabled:   !window.FEATURE_TOGGLES.prisk_new_911_emergency,
        hasTooltip: false
      },
      {
        name:       threeWayCallName,
        value:      PREFERENCE_TYPES.threeWayCall,
        disabled:   true,
        hasTooltip: false
      },
      {
        name:       liveAgentName,
        value:      PREFERENCE_TYPES.liveAgent,
        disabled:   false,
        hasTooltip: false
      },
      {
        name:       emotionalDistress,
        value:      PREFERENCE_TYPES.emotionalDistress,
        disabled:   !window.FEATURE_TOGGLES.prisk_new_911_emergency,
        hasTooltip: false
      }
    ]
  }
};
